{
  "familyId": "TOPO-WERELD-CONT",
  "questions": [
    {
      "id": "TOPO-WERELD-CONT-001",
      "familyId": "TOPO-WERELD-CONT",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_continenten",
      "questionType": "multiple_choice",
      "question": "Op welk continent ligt Brazilië?",
      "context": null,
      "options": ["Zuid-Amerika", "Afrika", "Noord-Amerika", "Europa"],
      "correctAnswer": 0,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Brazilië in Zuid-Amerika",
            "content": "Brazilië is het grootste land van Zuid-Amerika. Het grenst aan bijna alle andere Zuid-Amerikaanse landen. De hoofdstad is Brasilia, de grootste stad is São Paulo.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "continents_countries",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Koppel landen aan continenten via hun ligging op de wereldkaart. Brazilië ligt in het oosten van Zuid-Amerika, aan de Atlantische Oceaan. Het is het grootste land van Zuid-Amerika en beslaat bijna de helft van het continent. De voertaal is Portugees, niet Spaans zoals in de meeste andere Zuid-Amerikaanse landen.",
        "solutionSteps": [
          "Zoek Brazilië op de wereldkaart",
          "Brazilië ligt in het oosten van Zuid-Amerika, aan de Atlantische Oceaan",
          "Het is het grootste land van dat continent en beslaat bijna de helft ervan",
          "De voertaal is Portugees (niet Spaans, zoals in de meeste buurlanden)"
        ],
        "distractorExplanations": {
          "0": "Correct! Brazilië ligt in Zuid-Amerika, het is zelfs het grootste land van dat continent.",
          "1": "Brazilië en Afrika liggen aan weerszijden van de Atlantische Oceaan. Er zijn historische banden tussen beide, maar Brazilië ligt in Zuid-Amerika, niet in Afrika.",
          "2": "Noord-Amerika omvat de VS, Canada en Mexico. Brazilië ligt in Zuid-Amerika, het continent ten zuiden van het Panamakanaal.",
          "3": "Portugal ligt in Europa, maar Brazilië (een voormalige Portugese kolonie) ligt in Zuid-Amerika. De Portugese taal kan verwarrend zijn, maar het land zelf ligt op een ander continent."
        }
      }
    },
    {
      "id": "TOPO-WERELD-CONT-002",
      "familyId": "TOPO-WERELD-CONT",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_continenten",
      "questionType": "multiple_choice",
      "question": "Op welk continent ligt Egypte?",
      "context": null,
      "options": ["Afrika", "Azië", "Europa", "Zuid-Amerika"],
      "correctAnswer": 0,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Egypte in Afrika",
            "content": "Egypte ligt in het noordoosten van Afrika, aan de Middellandse Zee en de Rode Zee. De Nijl stroomt door Egypte. Een klein deel (Sinaï) ligt in Azië, maar het grootste deel ligt in Afrika.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "continents_countries",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Bij grensgevallen kijk je waar het grootste deel van het land ligt. Egypte ligt in het noordoosten van Afrika, aan de Middellandse Zee en de Rode Zee. De Nijl, de langste rivier van Afrika, stroomt door Egypte. Een klein deel (het Sinaï-schiereiland) ligt in Azië, maar de hoofdstad Caïro en het grootste deel liggen in Afrika.",
        "solutionSteps": [
          "Zoek Egypte op de wereldkaart — het ligt in het noordoosten van Afrika",
          "De Nijl (langste rivier van Afrika) stroomt door Egypte",
          "Een klein deel (Sinaï) ligt in Azië, maar het grootste deel ligt in Afrika",
          "Egypte wordt daarom tot Afrika gerekend"
        ],
        "distractorExplanations": {
          "0": "Correct! Egypte ligt in Afrika, aan de noordoostkant van het continent.",
          "1": "Een klein deel van Egypte (het Sinaï-schiereiland) ligt inderdaad in Azië, maar het grootste deel van het land en de hoofdstad Caïro liggen in Afrika. Egypte wordt tot Afrika gerekend.",
          "2": "Egypte ligt aan de zuidkust van de Middellandse Zee, in Afrika. Europa ligt aan de noordkust. De Middellandse Zee scheidt de twee continenten van elkaar.",
          "3": "Zuid-Amerika ligt aan de andere kant van de wereld. Egypte ligt in het noordoosten van Afrika, ver van Zuid-Amerika."
        }
      }
    },
    {
      "id": "TOPO-WERELD-CONT-003",
      "familyId": "TOPO-WERELD-CONT",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_continenten",
      "questionType": "multiple_choice",
      "question": "Hoeveel continenten zijn er op de wereld?",
      "context": null,
      "options": ["7", "5", "6", "8"],
      "correctAnswer": 0,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De 7 continenten",
            "content": "Er zijn 7 continenten: Europa, Azië, Afrika, Noord-Amerika, Zuid-Amerika, Oceanië (Australië) en Antarctica. Sommige mensen tellen er 5 of 6, maar in Nederland leren we er 7.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "continents_count",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Leer de 7 continenten als een vast rijtje. De 7 continenten zijn: Europa, Azië, Afrika, Noord-Amerika, Zuid-Amerika, Oceanië (Australië) en Antarctica. In Nederland gebruiken we de 7-continentenindeling. Andere landen gebruiken soms 5 of 6 door continenten samen te voegen.",
        "solutionSteps": [
          "De 7 continenten zijn: Europa, Azië, Afrika, Noord-Amerika, Zuid-Amerika, Oceanië en Antarctica",
          "In Nederland leren we de 7-continentenindeling",
          "Ezelsbruggetje: 'EAANZO-A' (Europa, Azië, Afrika, Noord-Amerika, Zuid-Amerika, Oceanië, Antarctica)"
        ],
        "distractorExplanations": {
          "0": "Correct! Er zijn 7 continenten op de wereld.",
          "1": "De 5 Olympische ringen staan voor 5 bewoonde continenten, maar op school leren we 7 continenten. Dat is inclusief Antarctica en met Noord- en Zuid-Amerika als aparte continenten.",
          "2": "Bij 6 vergeet je waarschijnlijk Antarctica, de zuidpool. Hoewel er niemand permanent woont, is Antarctica wel een continent. In totaal zijn er 7 continenten.",
          "3": "Er zijn 7 continenten, niet 8. Mogelijk tel je een groot eiland zoals Groenland als apart continent, maar dat hoort bij Noord-Amerika."
        }
      }
    },
    {
      "id": "TOPO-WERELD-CONT-004",
      "familyId": "TOPO-WERELD-CONT",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_continenten",
      "questionType": "multiple_choice",
      "question": "Welk continent is het grootst qua oppervlakte?",
      "context": null,
      "options": ["Azië", "Afrika", "Noord-Amerika", "Europa"],
      "correctAnswer": 0,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grootste continent",
            "content": "Azië is het grootste continent (44,6 miljoen km²). Het is groter dan Afrika (30,4 miljoen km²), Noord-Amerika (24,7 miljoen km²) en Europa (10,2 miljoen km²).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "continents_largest",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Vergelijk de oppervlaktes van de continenten. Azië is met 44,6 miljoen km² veruit het grootste continent. Het omvat landen als Rusland (deels), China, India en Indonesië. De rangorde is: Azië (44,6) > Afrika (30,4) > Noord-Amerika (24,7) > Zuid-Amerika (17,8) > Antarctica (14,2) > Europa (10,2) > Oceanië (8,5).",
        "solutionSteps": [
          "Azië is met 44,6 miljoen km² het grootste continent",
          "Afrika is het op één na grootste (30,4 miljoen km²)",
          "De volgorde is: Azië > Afrika > Noord-Amerika > Zuid-Amerika > Antarctica > Europa > Oceanië",
          "Azië is ruim 4 keer zo groot als Europa"
        ],
        "distractorExplanations": {
          "0": "Correct! Azië is met 44,6 miljoen km² het grootste continent ter wereld.",
          "1": "Afrika is het op één na grootste continent met 30,4 miljoen km², maar Azië is nog groter met 44,6 miljoen km². Op sommige kaartprojecties lijkt Afrika groter dan het werkelijk is.",
          "2": "Noord-Amerika is met 24,7 miljoen km² het derde continent qua grootte, maar Azië (44,6 miljoen km²) is bijna twee keer zo groot.",
          "3": "Europa heeft veel landen, maar is qua oppervlakte een van de kleinste continenten met 10,2 miljoen km². Azië is ruim 4 keer zo groot als Europa."
        }
      }
    },
    {
      "id": "TOPO-WERELD-CONT-005",
      "familyId": "TOPO-WERELD-CONT",
      "module": "Topo",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "wereld",
      "subSkill": "topo_continenten",
      "questionType": "multiple_choice",
      "question": "Welke oceaan ligt tussen Europa/Afrika en Amerika?",
      "context": null,
      "options": ["De Atlantische Oceaan", "De Stille Oceaan", "De Indische Oceaan", "De Noordelijke IJszee"],
      "correctAnswer": 0,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.71,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Oceanen",
            "content": "De Atlantische Oceaan ligt tussen Amerika (westkant) en Europa/Afrika (oostkant). De Stille Oceaan ligt tussen Amerika en Azië/Oceanië. De Indische Oceaan ligt tussen Afrika, Azië en Australië.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "oceans_atlantic",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Koppel elke oceaan aan de continenten die het scheidt. De Atlantische Oceaan ligt tussen Amerika (westkant) en Europa/Afrika (oostkant). Het is de op één na grootste oceaan. De drie grote oceanen zijn: Atlantische Oceaan (tussen Amerika en Europa/Afrika), Stille Oceaan (tussen Amerika en Azië) en Indische Oceaan (tussen Afrika, Azië en Australië).",
        "solutionSteps": [
          "De Atlantische Oceaan ligt tussen Amerika en Europa/Afrika",
          "De Stille Oceaan ligt tussen Amerika en Azië/Oceanië",
          "De Indische Oceaan ligt tussen Afrika, Azië en Australië",
          "De Atlantische Oceaan is de op één na grootste oceaan ter wereld"
        ],
        "distractorExplanations": {
          "0": "Correct! De Atlantische Oceaan ligt tussen Europa/Afrika en Amerika.",
          "1": "De Stille Oceaan (Pacific) ligt tussen Amerika en Azië/Oceanië — aan de andere kant van Amerika. De Atlantische Oceaan scheidt Amerika van Europa en Afrika.",
          "2": "De Indische Oceaan ligt tussen Afrika, Azië en Australië, niet tussen Europa en Amerika. De Atlantische Oceaan is de oceaan die Europa/Afrika van Amerika scheidt.",
          "3": "De Noordelijke IJszee (Arctische Oceaan) ligt rond de Noordpool en is de kleinste oceaan. De Atlantische Oceaan is de grote oceaan tussen Europa/Afrika en Amerika."
        }
      }
    }
  ]
}